module.exports = __webpack_public_path__ + "img/6.b374d855.png";